import React, { useState } from 'react';
import { Button } from '../../design-system/Button';
import { coachOnboardingAPI } from '../../../api/coachApi';

interface AvailabilityStepProps {
  onComplete: () => void;
  onSkip?: () => void;
  progress?: any;
}

const AvailabilityStep: React.FC<AvailabilityStepProps> = ({ onComplete }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');
      
      // For now, submit default availability
      await coachOnboardingAPI.setupAvailability({
        primary_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        working_hours: {
          monday: { enabled: true, start: '09:00', end: '17:00' },
          tuesday: { enabled: true, start: '09:00', end: '17:00' },
          wednesday: { enabled: true, start: '09:00', end: '17:00' },
          thursday: { enabled: true, start: '09:00', end: '17:00' },
          friday: { enabled: true, start: '09:00', end: '17:00' },
          saturday: { enabled: false },
          sunday: { enabled: false },
        },
        session_durations: [30, 45, 60],
        default_session_duration: 60,
      });
      
      onComplete();
    } catch (err: any) {
      setError(err.message || 'Failed to update availability');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      )}

      <div className="text-center py-8">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Availability Setup
        </h3>
        <p className="text-gray-600 mb-6">
          Full availability configuration will be available here.
        </p>
        <p className="text-sm text-gray-500">
          For now, we'll set up standard business hours (Mon-Fri, 9am-5pm).
        </p>
      </div>

      <div className="flex justify-end">
        <Button onClick={handleSubmit} isLoading={loading} size="lg">
          Continue with Default Availability
        </Button>
      </div>
    </div>
  );
};

export default AvailabilityStep;